import React from 'react';
import { Link } from 'react-router-dom'

const Montono2 = (props) => {

    const data = props.data;

    return (
        <section className="tf-section montono" id='portfolio'>
            
            <div className="container">
                <div className="row mt-52">
                    {
                        data.slice(8,30).map((data,index) => (
                            <div key={index} className="col-xl-4 col-md-6">
                                <div className="image-box" data-aos="fade-up" data-aos-duration="1000">
                                    <img src={data.img} alt={`${data.title} professional photography portfolio example`} />
                                    <div className="image-box__title">
                                        <Link to="/collections" className="h6">{data.title}</Link>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                  
                </div>
            </div>
        </section>
    );
}

export default Montono2;